import "./styles.css";
import React, { useReducer } from "react";
import Chart from "./PriceChart";
import RangeSlider from "./rangeSlider";
import Dialog from "./Dialog";
import DebtDialog from "./DebtDialog";
import Alert from "./Alert";

function appReducer(state, action) {
  // console.log(action);
  switch (action.type) {
    case "field": {
      return {
        ...state,
        [action.field]: action.value
      };
    }

    case "bank-deposit-click": {
      return {
        ...state,
        qty_max: state.priceChart.cash,
        qty: state.priceChart.cash,
        item_name: "Deposit Cash!",
        action: "Deposit",
        show_slider: true
      };
    }
    case "bank-withdraw-click": {
      return {
        ...state,
        qty_max: state.priceChart.bank,
        qty: state.priceChart.bank,
        item_name: "Withdraw Cash!",
        action: "Withdraw",
        show_slider: true
      };
    }
    case "loan-take-click": {
      return {
        ...state,
        qty_max: 500,
        item_name: "Take Loan!",
        action: "Take Debt",

        show_slider: true,
        showDialog: false,
        debtShowDialog: false
      };
    }
    case "hide-slider": {
      return {
        ...state,
        show_slider: false
      };
    }
    default:
      break;
  }

  return state;
}

let w_price = Math.floor(Math.random() * (850 - 25 + 1)) + 25;
let p_price = Math.floor(Math.random() * (3050 - 880 + 1)) + 880;
let c_price = Math.floor(Math.random() * (80000 - 30000 + 1)) + 30000;
let h_price = Math.floor(Math.random() * (40000 - 5000 + 1)) + 5000;
let a_price = Math.floor(Math.random() * (4500 - 900 + 1)) + 900;
let l_price = Math.floor(Math.random() * (70 - 4 + 1)) + 4;

const initialState = {
  priceChart: {
    cash: 10000,
    bank: 0,
    debt: 5500,
    items: [
      { name: "weed", price: w_price, qty: 0 },
      { name: "cocaine", price: c_price, qty: 0 },
      { name: "heroine", price: h_price, qty: 0 },
      { name: "acid", price: a_price, qty: 0 },
      { name: "ludes", price: l_price, qty: 0 },
      { name: "pcp", price: p_price, qty: 0 }
    ]
  },
  currentArea: "bankner",
  days: 10,
  message: "",
  dialogContent: "",
  showDialog: false,
  debtDialogContent: "",
  debtShowDialog: false,
  qty_max: 0,
  show_slider: "",
  item_name: "",
  qty: 0,
  action: "",
  location: ["bankner", "narela", "bawana", "alipur", "azadpur"]
};

export default function App() {
  const [state, dispatch] = useReducer(appReducer, initialState);

  const {
    qty_max,
    qty,
    show_slider,
    action,
    item_name,
    priceChart,
    currentArea,
    days,
    message,
    dialogContent,
    showDialog,
    debtDialogContent,
    debtShowDialog,
    location
  } = state;

  const inputRef = React.useRef();

  const cash = priceChart.cash;
  const bank = priceChart.bank;
  const debt = priceChart.debt;
  const items = priceChart.items;

  function handleLoanPay() {
    if (priceChart.cash > priceChart.debt) {
      dispatch({ type: "field", field: "qty_max", value: priceChart.debt });
      dispatch({ type: "field", field: "qty", value: priceChart.debt });
    } else {
      dispatch({ type: "field", field: "qty", value: priceChart.cash });
      dispatch({ type: "field", field: "qty_max", value: priceChart.cash });
    }
    if (priceChart.debt <= 0) {
      dispatch({
        type: "field",
        field: "message",
        value: "You dont have any debt"
      });
      dispatch({ type: "field", field: "qty_max", value: 0 });
      dispatch({ type: "field", field: "debtShowDialog", value: false });
      return false;
    }
    dispatch({ type: "field", field: "item_name", value: "Pay Loan!" });
    dispatch({ type: "field", field: "action", value: "Pay Debt" });
    dispatch({ type: "field", field: "show_slider", value: true });
  }

  function hideAlert() {
    dispatch({ type: "field", field: "message", value: "" });
  }

  function reset_to_default() {
    dispatch({
      type: "field",
      field: "priceChart",
      value: {
        cash: 10000,
        bank: 0,
        debt: 5500,
        items: [
          { name: "weed", price: w_price, qty: 0 },
          { name: "cocaine", price: c_price, qty: 0 },
          { name: "heroine", price: h_price, qty: 0 },
          { name: "acid", price: a_price, qty: 0 },
          { name: "ludes", price: l_price, qty: 0 },
          { name: "pcp", price: p_price, qty: 0 }
        ]
      }
    });
    dispatch({ type: "field", field: "days", value: 10 });
    dispatch({ type: "field", field: "currentArea", value: "bankner" });
  }

  function setPrices() {
    let w_price = Math.floor(Math.random() * (850 - 25 + 1)) + 25;
    let p_price = Math.floor(Math.random() * (3050 - 880 + 1)) + 880;
    let c_price = Math.floor(Math.random() * (80000 - 30000 + 1)) + 30000;
    let h_price = Math.floor(Math.random() * (40000 - 5000 + 1)) + 5000;
    let a_price = Math.floor(Math.random() * (4500 - 900 + 1)) + 900;
    let l_price = Math.floor(Math.random() * (70 - 4 + 1)) + 4;
    priceChart.items.filter((p) => p.name === "weed")[0].price = w_price;
    priceChart.items.filter((p) => p.name === "cocaine")[0].price = c_price;
    priceChart.items.filter((p) => p.name === "heroine")[0].price = h_price;
    priceChart.items.filter((p) => p.name === "acid")[0].price = a_price;
    priceChart.items.filter((p) => p.name === "ludes")[0].price = l_price;
    priceChart.items.filter((p) => p.name === "pcp")[0].price = p_price;
  }

  function changeLocation(area) {
    if (currentArea === area) {
      dispatch({
        type: "field",
        field: "message",
        value: `You are already in ${area.replace(/^\w/, (c) =>
          c.toUpperCase()
        )}`
      });
      return false;
    }
    const new_debt = Math.round(debt + (debt * 10) / 100);
    const new_bank = Math.round(bank + (bank * 2) / 100);
    setPrices();
    dispatch({ type: "field", field: "days", value: days - 1 });

    if (days <= 0) {
      let score = bank + cash - debt;
      dispatch({ type: "field", field: "qty_max", value: 0 });
      dispatch({
        type: "field",
        field: "message",
        value: `Game Over, Your Score is ${score}`
      });
      reset_to_default();
      return 0;
    }
    dispatch({
      type: "field",
      field: "priceChart",
      value: { cash: cash, bank: new_bank, debt: new_debt, items: [...items] }
    });

    dispatch({ type: "field", field: "currentArea", value: area });
  }

  function max_qty(price, cash) {
    let quantity = 0;
    let total = 0;
    for (let i = 0; i < cash; i++) {
      if (cash > total) {
        quantity++;
        total = price * quantity;
      }
      if (total === cash) {
        return quantity;
      }
      if (total > cash) {
        return quantity - 1;
      }
    }
    return quantity;
  }

  function buyN(item_name, qty) {
    qty = parseInt(qty, 10);

    const item = priceChart.items.filter((p) => p.name === item_name)[0];

    const new_item = item;
    if (item.price > cash) {
      dispatch({
        type: "field",
        field: "message",
        value: "You dont have enough cash"
      });
      return 0;
    }
    if (new_item) {
      new_item.qty += qty;
    }
    const new_cash = cash - item.price * qty;
    dispatch({
      type: "field",
      field: "priceChart",
      value: { cash: new_cash, bank: bank, debt: debt, items: [...items] }
    });

    hide_slider();
  }

  function sellN(item_name, qty) {
    qty = parseInt(qty, 10);
    const item = priceChart.items.filter((p) => p.name === item_name)[0];

    if (item.qty > 0) {
      item.qty -= qty;
    } else {
      dispatch({
        type: "field",
        field: "message",
        value: `You dont have any ${item_name} left`
      });
      hide_slider();
      return false;
    }
    const new_cash = cash + item.price * qty;
    dispatch({
      type: "field",
      field: "priceChart",
      value: { cash: new_cash, bank: bank, debt: debt, items: [...items] }
    });
    hide_slider();
  }

  function buyOne(item_name) {
    buyItem(item_name);
  }

  function sellOne(item_name) {
    sellItem(item_name);
  }

  function buyItem(item_name) {
    const item = priceChart.items.filter((p) => p.name === item_name)[0];
    const qty = max_qty(item.price, cash);
    if (qty <= 0) {
      dispatch({
        type: "field",
        field: "message",
        value: `You can't buy ${item_name}`
      });

      return 0;
    }
    dispatch({ type: "field", field: "item_name", value: item_name });
    dispatch({ type: "field", field: "action", value: "Buy" });
    dispatch({ type: "field", field: "qty_max", value: qty });
    dispatch({ type: "field", field: "qty", value: qty });
    dispatch({ type: "field", field: "show_slider", value: true });
  }

  function sellItem(item_name) {
    const item = priceChart.items.filter((p) => p.name === item_name)[0];
    const qty = item.qty;
    if (qty <= 0) {
      dispatch({
        type: "field",
        field: "message",
        value: `You don't have any ${item_name} left`
      });

      return 0;
    }
    dispatch({ type: "field", field: "action", value: "Sell" });
    dispatch({ type: "field", field: "item_name", value: item_name });
    dispatch({ type: "field", field: "qty_max", value: qty });
    dispatch({ type: "field", field: "qty", value: qty });
    dispatch({ type: "field", field: "show_slider", value: true });
  }

  function hide_slider() {
    dispatch({ type: "hide-slider" });
  }

  function handleValue(e, name) {
    dispatch({ type: "field", field: "qty", value: inputRef.current.value });
  }

  function handleClick(item_name) {
    const item = priceChart.items.filter((p) => p.name === item_name)[0];

    if (item.qty <= 0) {
      buyItem(item_name);
    } else if (item.qty > 0 && cash < item.price) {
      sellItem(item_name);
    } else if (item.qty > 0) {
      dispatch({ type: "field", field: "item_name", value: item_name });
    }
  }

  //
  function handleSetAction(action, item_name) {
    if (action === "buy") {
      buyItem(item_name);
    } else if (action === "sell") {
      sellItem(item_name);
    } else if (action === "deposit") {
      dispatch({ type: "field", field: "showDialog", value: false });
      dispatch({ type: "bank-deposit-click" });
    } else if (action === "withdraw") {
      dispatch({ type: "field", field: "showDialog", value: false });
      dispatch({ type: "bank-withdraw-click" });
    } else if (action === "cancel") {
      dispatch({ type: "field", field: "showDialog", value: false });
      dispatch({ type: "field", field: "debtShowDialog", value: false });
    } else if (action === "pay-loan") {
      dispatch({ type: "field", field: "showDialog", value: false });
      dispatch({ type: "field", field: "debtShowDialog", value: false });
      handleLoanPay();
    } else if (action === "take-loan") {
      dispatch({ type: "loan-take-click" });
    } else {
      console.log(action, item_name);
    }
  }

  function handleDeposit(qty) {
    let amount = parseInt(qty, 10);

    if (cash < amount) {
      hide_slider();
      dispatch({ type: "field", field: "qty_max", value: priceChart.cash });
      dispatch({
        type: "field",
        field: "message",
        value: "You dont have enough cash!!!"
      });

      return false;
    }
    const new_cash = cash - amount;
    const new_bank = bank + amount;

    dispatch({
      type: "field",
      field: "priceChart",
      value: { cash: new_cash, bank: new_bank, debt: debt, items: [...items] }
    });

    hide_slider();
  }
  function handleWithdraw(qty) {
    let amount = parseInt(qty, 10);
    if (amount > bank) {
      hide_slider();
      dispatch({ type: "field", field: "qty_max", value: priceChart.bank });
      dispatch({
        type: "field",
        field: "message",
        value: "Not enough bank balance!!!"
      });
      return 0;
    }
    const new_cash = cash + amount;
    const new_bank = bank - amount;
    dispatch({
      type: "field",
      field: "priceChart",
      value: { cash: new_cash, bank: new_bank, debt: debt, items: [...items] }
    });
    hide_slider();
  }

  function handleLoanPaid(qty) {
    let amount = parseInt(qty, 10);

    if (amount > debt) {
      dispatch({ type: "field", field: "qty_max", value: priceChart.debt });
      dispatch({
        type: "field",
        field: "message",
        value: "You dont have any debt"
      });
      dispatch({ type: "field", field: "show_slider", value: false });
      return false;
    }
    const new_cash = cash - amount;
    const new_debt = debt - amount;
    dispatch({
      type: "field",
      field: "priceChart",
      value: { cash: new_cash, bank: bank, debt: new_debt, items: [...items] }
    });
    hide_slider();
  }
  function handleLoanTaken(qty) {
    let amount = parseInt(qty, 10);

    const new_cash = cash + amount;
    const new_debt = debt + amount;
    dispatch({
      type: "field",
      field: "priceChart",
      value: { cash: new_cash, bank: bank, debt: new_debt, items: [...items] }
    });
    hide_slider();
  }

  function handleAction(item_name, qty, action) {
    if (action === "buy" || action === "Buy") {
      buyN(item_name, qty);
    } else if (action === "sell" || action === "Sell") {
      sellN(item_name, qty);
    } else if (action === "Deposit" || action === "Deposit Cash!") {
      handleDeposit(qty);
    } else if (action === "Withdraw" || action === "Withdraw Cash!") {
      handleWithdraw(qty);
    } else if (action === "pay-debt" || action === "Pay Debt") {
      handleLoanPaid(qty);
    } else if (action === "take-debt" || action === "Take Debt") {
      handleLoanTaken(qty);
    }
  }

  return (
    <div className="App">
      <h1 className="status-bar">
        In: {currentArea.replace(/^\w/, (c) => c.toUpperCase())} | CASH: $
        {priceChart.cash} | DAYS LEFT: {days}
      </h1>
      <h2>
        <button
          onClick={() => {
            dispatch({
              type: "field",
              field: "dialogContent",
              value: "Welcome to citi bank"
            });
            dispatch({ type: "field", field: "showDialog", value: true });
          }}
        >
          Bank: ${priceChart.bank}
        </button>
        <button
          onClick={() => {
            dispatch({
              type: "field",
              field: "debtDialogContent",
              value: "Need Money ??"
            });
            dispatch({ type: "field", field: "debtShowDialog", value: true });
          }}
        >
          DEBT: ${priceChart.debt}
        </button>
      </h2>
      <div className="d_row">
        <h4>Where To?</h4>
        <br />
        {location.map((i, index) => (
          <button
            className={i === currentArea ? "btn-disabled" : "location-btn"}
            key={index}
            onClick={(e) => changeLocation(i, e)}
          >
            {i.replace(/^\w/, (c) => c.toUpperCase())}
          </button>
        ))}
      </div>
      <Alert message={message} hideAlert={hideAlert} />
      {/* TOODS: */}
      {/*  */}
      {/* color coded price indicator Done */}
      {/* Pocket sizes aka quanitity restriction */}
      {/* RPG elements with health & guns & cops */}
      {/* Mugger & robbery */}
      {/* msgs for all time high price & low price */}
      {/*  */}
      <Chart
        data={priceChart}
        buybtn={buyOne}
        sellbtn={sellOne}
        buyItem={buyItem}
        handleClick={handleClick}
      />
      <RangeSlider
        min={1}
        max={qty_max}
        item_name={item_name}
        name={action}
        inputRef={inputRef}
        qty={qty}
        handleValue={handleValue}
        showSlider={show_slider}
        hideSlider={hide_slider}
        handleAction={handleAction}
      />
      <Dialog
        showDialog={showDialog}
        dialogContent={dialogContent}
        setAction={handleSetAction}
      />
      <DebtDialog
        debtShowDialog={debtShowDialog}
        debtDialogContent={debtDialogContent}
        setAction={handleSetAction}
      />
    </div>
  );
}
